import Config from "../../../Configs";
import { ApiResponse, GetAllRawMaterialsResponse, AddRawMaterialRequest, AddRawMaterialResponse, RawMaterial } from "../../../Models";
import { IHttpService } from "../IHttpService";
import { ApiServiceBase } from "./ApiServiceBase";

export default class RawMaterialsApiService extends ApiServiceBase {
    constructor(client: IHttpService) {
        super(client);
    }

    async getAllRawMaterials(): Promise<ApiResponse<GetAllRawMaterialsResponse>> {
        return await this._client.get<GetAllRawMaterialsResponse>(Config.apiPaths.getRawMaterials);
    }

    async addRawMaterials(data: AddRawMaterialRequest): Promise<ApiResponse<AddRawMaterialResponse>> {
        return await this._client.post<AddRawMaterialResponse>(Config.apiPaths.addRawMaterials, data);
    }

    async getRawMaterialBank(): Promise<ApiResponse<RawMaterial[]>> {
        return await this._client.get<RawMaterial[]>(Config.apiPaths.getRawMaterialsBank);
    }
    async deleteRawMaterial(itemId: number): Promise<ApiResponse<string>> {
        return await this._client.post(Config.apiPaths.deleteRawMaterial.replace("{0}", itemId.toString()));
    }
}
